import MainLayout from "@/components/layout/applicant/MainLayout.vue";
import $ from "jquery";
import DatePicker from 'vue2-datepicker';
import NrcNameJson from "@/assets/json/nrc_list.json";
import NaingJson from "@/assets/json/naing.json";
import RegionJson from "@/assets/json/region.json";
import {
    required,
    email,
    minLength,
    maxLength,
} from 'vuelidate/lib/validators';
import {
    ConvertNumService
} from '@/assets/js/convertNumberService.js';
import axios from "axios";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

const convertNumberService = new ConvertNumService();

export default {
    name: "resumeIndex",
    components: {
        MainLayout,
        DatePicker,
        Loading
    },

    data() {
        return {
            imageError: '',
            isLoading: false,
            fullPage: true,
            resumeForm: {
                applicant_id: this.$store.state.applicant.applicant['id'],
                name: "",
                nrc_number: "",
                nrc_only_number: "",
                profile_image: "",
                nationality: "",
                religion: "",
                date_of_birth: "",
                email: "",
                phone_number: "",
                facebook: "",
                linkin: "",
                gender: 1,
                marital_status: 2,
                contact_address: "",
                permanent_address: "",
                experience_detail: "",
                education_detail: "",
                other_certificate: "",
                position: "",
                expected_salary: "",
                nrc: ""
            },
            nrcno: [
                { value: "1", name: "၁" },
                { value: "2", name: "၂" },
                { value: "3", name: "၃" },
                { value: "4", name: "၄" },
                { value: "5", name: "၅" },
                { value: "6", name: "၆" },
                { value: "7", name: "၇" },
                { value: "8", name: "၈" },
                { value: "9", name: "၉" },
                { value: "10", name: "၁၀" },
                { value: "11", name: "၁၁" },
                { value: "12", name: "၁၂" },
                { value: "13", name: "၁၃" },
                { value: "14", name: "၁၄" }
            ],
            submitted: false,
            profile_image: '',
            isDragOver: false,
            nrcNameJson: NrcNameJson,
            naingJson: NaingJson,
            regionArr: RegionJson,
            nrckeyVal: "",
            nrckey: "",
            selectedNrcName: "",
            selectedNrcNaing: "",
            districtList: [],
            naingList: [],
            nrcName: [],
            isNrcDropdownOpen: false,
            isNrcNameDropdownOpen: false,
            isNrcNaingDropdownOpen: false,
        };
    },

    validations: {
        resumeForm: {
            name: {
                required,
                maxLength: maxLength(100)
            },
            nrc_number: {
                required,
                minLength: minLength(6),
                maxLength: maxLength(6)
            },
            nationality: {
                required,
                maxLength: maxLength(100)
            },
            religion: {
                required,
                maxLength: maxLength(100)
            },
            date_of_birth: {
                required
            },
            email: {
                required,
                email,
                maxLength: maxLength(100)
            },
            phone_number: {
                required,
                minLength: minLength(9),
                maxLength: maxLength(11),
            },
            facebook: {
                maxLength: maxLength(255)
            },
            linkin: {
                maxLength: maxLength(255)
            },
            gender: {
                required
            },
            marital_status: {
                required
            },
            contact_address: {
                required,
                maxLength: maxLength(200)
            },
            permanent_address: {
                maxLength: maxLength(200)
            },
            position: {
                required,
                maxLength: maxLength(100)
            },
            expected_salary: {
                maxLength: maxLength(20)
            },
            experience_detail: {
                maxLength: maxLength(1000)
            },
            education_detail: {
                required,
                maxLength: maxLength(1000)
            },
            other_certificate: {
                maxLength: maxLength(1000)
            },
        }
    },

    methods: {
        onProfileChange(e) {
            let files = e.target.files || (e.dataTransfer && e.dataTransfer.files);
            if (!files || !files.length) return;

            const file = files[0];
            this.imageError = '';

            // Image format validation
            if (!file.type.match('image.*')) {
                this.$notification.error("ပုံစံစနစ်တကျဖြစ်သော image ဖိုင်ကိုသာ တင်ပေးပါ။", {
                    timer: 3,
                    position: "bottomCenter"
                });
                if (this.$refs.fileInput) {
                    this.$refs.fileInput.value = '';
                }
                return;
            }

            // 1MB File Size validation
            const maxSize = 1 * 1024 * 1024;
            if (file.size > maxSize) {
                this.imageError = 'ဓာတ်ပုံဖိုင်ဆိုဒ် 1MB ထက် မပိုရပါ။';
                if (this.$refs.fileInput) {
                    this.$refs.fileInput.value = '';
                }
                return;
            }

            this.resumeForm.profile_image = file;
            let reader = new FileReader();
            reader.onload = event => {
                this.profile_image = event.target.result;
            };
            reader.readAsDataURL(file);
        },

        imgRemove() {
            this.profile_image = '';
            this.imageError = '';
            this.resumeForm.profile_image = '';
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = '';
            }
        },

        onDragOver() {
            this.isDragOver = true;
        },

        onDragLeave() {
            this.isDragOver = false;
        },

        onDrop(e) {
            this.isDragOver = false;
            let files = e.dataTransfer.files;
            if (!files || !files.length) return;

            const file = files[0];
            if (file.type.match('image.*')) {
                const dataTransfer = new DataTransfer();
                dataTransfer.items.add(file);
                if (this.$refs.fileInput) {
                    this.$refs.fileInput.files = dataTransfer.files;
                }
                this.onProfileChange({ target: { files: [file] } });
            } else {
                this.$notification.error("ပုံစံစနစ်တကျဖြစ်သော image ဖိုင်ကိုသာ တင်ပေးပါ။", {
                    timer: 3,
                    position: "bottomCenter"
                });
            }
        },

        toggleNrcDropdown() {
            this.isNrcDropdownOpen = !this.isNrcDropdownOpen;
            this.isNrcNameDropdownOpen = false;
            this.isNrcNaingDropdownOpen = false;
        },

        toggleNrcNameDropdown() {
            if (!this.nrckeyVal) return;
            this.isNrcNameDropdownOpen = !this.isNrcNameDropdownOpen;
            this.isNrcDropdownOpen = false;
            this.isNrcNaingDropdownOpen = false;
        },

        toggleNrcNaingDropdown() {
            if (!this.selectedNrcName) return;
            this.isNrcNaingDropdownOpen = !this.isNrcNaingDropdownOpen;
            this.isNrcDropdownOpen = false;
            this.isNrcNameDropdownOpen = false;
        },

        selectNrc(value, name) {
            this.nrckeyVal = value;
            this.nrckey = name;
            this.onChange();
            this.isNrcDropdownOpen = false;
        },

        selectNrcName(value) {
            this.selectedNrcName = value;
            this.onChangeNrcName();
            this.isNrcNameDropdownOpen = false;
        },

        selectNrcNaing(value) {
            this.selectedNrcNaing = value;
            this.isNrcNaingDropdownOpen = false;
        },

        handleOutsideClick(e) {
            if (!e.target.closest('.custom-select-wrapper')) {
                this.isNrcDropdownOpen = false;
                this.isNrcNameDropdownOpen = false;
                this.isNrcNaingDropdownOpen = false;
            }
        },

        onChange() {
            if (this.nrckeyVal) {
                const matched = this.nrcno.find(option => option.value === this.nrckeyVal);
                this.nrckey = matched ? matched.name : "";
                this.districtList = this.changeNrcName(this.nrckeyVal);
            } else {
                this.nrckey = "";
                this.districtList = [];
            }
            this.selectedNrcName = "";
            this.selectedNrcNaing = "";
        },

        changeNrcName(value) {
            return this.nrcNameJson[value - 1];
        },

        onChangeNrcName() {
            if (!this.selectedNrcName) {
                this.selectedNrcNaing = "";
                this.resumeForm.nrc_number = "";
            }
            this.naingList = this.naingJson;
        },

        checkNRC() {
            return !!(this.nrckey && this.selectedNrcName && this.selectedNrcNaing && this.resumeForm.nrc_number);
        },

        notAfterToday(date) {
            return date > new Date(new Date().setHours(0, 0, 0, 0));
        },

        mergeNRC() {
            return convertNumberService.convertEng2Mm(
                this.nrckey +
                "/" +
                this.selectedNrcName +
                this.selectedNrcNaing +
                this.resumeForm.nrc_number
            );
        },

        submitResume() {
            this.submitted = true;
            if (this.$v.resumeForm.$invalid || !this.checkNRC()) {
                return;
            }
            this.createResume();
        },

        createResume() {
            $("#block-btn").attr("disabled", true);
            this.isLoading = true;
            var nrc = this.mergeNRC();
            const data = new FormData();
            data.append('applicant_id', this.resumeForm.applicant_id);
            data.append('name', this.resumeForm.name);
            data.append('nrc_number', nrc);
            data.append('nrc_only_number', this.resumeForm.nrc_number);
            data.append('nationality', this.resumeForm.nationality);
            data.append('religion', this.resumeForm.religion);
            data.append('date_of_birth', this.resumeForm.date_of_birth);
            data.append('phone_number', this.resumeForm.phone_number);
            data.append('email', this.resumeForm.email);
            data.append('facebook', this.resumeForm.facebook);
            data.append('linkin', this.resumeForm.linkin);
            data.append('gender', this.resumeForm.gender);
            data.append('marital_status', this.resumeForm.marital_status);
            data.append('contact_address', this.resumeForm.contact_address);
            data.append('permanent_address', this.resumeForm.permanent_address);
            data.append('education_detail', this.resumeForm.education_detail);
            data.append('other_certificate', this.resumeForm.other_certificate);
            data.append('experience_detail', this.resumeForm.experience_detail);
            data.append('expected_salary', this.resumeForm.expected_salary);
            data.append('position', this.resumeForm.position);

            if (this.profile_image && this.profile_image.length < 10000000) {
                data.append('profile_image', this.profile_image);
            } else if (this.profile_image && this.profile_image.length > 10000000) {
                data.append('profile_image', '');
                $("#block-btn").attr("disabled", false);
            } else {
                data.append('profile_image', 'no-img');
            }

            axios.post("/applicant/resume/create", data)
                .then(response => {
                    if (response.data.img_error_msg) {
                        $("#block-btn").attr("disabled", false);
                        this.image_size = response.data.msg;
                        this.isLoading = false;
                        this.$notification.error("သတ်မှတ်ထားသော ပုံအရွယ်အစားထက်ကြီးနေပါတယ်။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    } else {
                        this.$notification.success("အလုပ်လျှောက်လွှာအောင်မြင်စွာ ပြုလုပ်ပြီးပါပြီ။", {
                            timer: 3,
                            position: 'bottomCenter'
                        });
                        this.isLoading = false;
                        this.$router.push({
                            name: "applicantIndex"
                        });
                    }
                })
                .catch(() => {
                    this.isLoading = false;
                    $("#block-btn").attr("disabled", false);
                    this.$notification.error("လုပ်ဆောင်ချက်မအောင်မြင်ပါ။", {
                        timer: 3,
                        position: 'bottomCenter'
                    });
                });
        },
    },

    mounted() {
        window.addEventListener('click', this.handleOutsideClick);
    },

    beforeDestroy() {
        window.removeEventListener('click', this.handleOutsideClick);
    }
};